/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const blockula: CommunityData = {
  code: "blockula",
  inviteCode: "blo22ckula",
  name: "Blockula",
  thumbnail: "https://media.werz.at/community-assets/BLOCKULA/web-logo.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/blo-137`,
  defaultCurrency: "SEK",
  socials: {},
  styles: {
    global: {
      counterColor: "#ffffff",
      logo: {
        src: "https://media.werz.at/community-assets/BLOCKULA/web-logo.png",
        styles: "w-[94px] h-[124px]",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/BLOCKULA/web-alternative-logo.png",
        styles: "w-[94px] h-[124px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "",
      contentBg: "#000000",
      contentBoxShadow: "",
      nonMemberBg: "https://media.werz.at/community-assets/BLOCKULA/web-background-non-member.jpg",
      bgDesktop: "https://media.werz.at/community-assets/BLOCKULA/web-background.jpg",
      bgMobile: "https://media.werz.at/community-assets/BLOCKULA/web-background-mobile.jpg",
      mainFont: "font-['RippleRegular']",
      primaryButton:
        "bg-[#000000] border border-white px-6 py-4 text-white font-['EBGaramondRegular'] text-base text-center",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "",
      separator: "border-b border-[#444444]",
      item: "text-white font-['RippleRegular'] text-base uppercase text-center leading-[110%] gap-x-[10px] -ml-2 !py-3",
      itemSelected: "",
    },
    communityLanding: {
      container: "bg-black rounded-[24px] !pb-8 overflow-hidden !pt-0",
      titles: "text-white font-['RippleRegular'] text-[30px] uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#a7a7a7] font-['CormorantGaramondRegular'] text-[15px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-white font-['RippleRegular'] text-[30px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] max-h-[256px] overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full h-[256px] bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-white font-['RippleRegular'] text-[20px] uppercase text-left leading-[110%]",
          subtitle: "text-[#a7a7a7] font-['CormorantGaramondRegular'] text-[15px] text-left",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-white font-['RippleRegular'] text-[30px] uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] overflow-hidden bg-[#ffffff00]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 sm:!h-[128px] relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title: "text-white font-['RippleRegular'] text-[20px] uppercase text-left leading-[110%]",
          subtitle: "text-[#a7a7a7] font-['EBGaramondRegular'] text-[15px] text-left",
          location: "text-[#a7a7a7] font-['EBGaramondRegular'] text-[15px] text-left",
          date: "text-[#a7a7a7] font-['EBGaramondRegular'] text-[15px] text-left",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-white font-['RippleRegular'] text-[24px] uppercase text-left leading-[110%]",
        text: "text-white font-['EBGaramondRegular'] text-base text-left",
        customShopImageStyle: "",
        sectionTitle:
          "text-white font-['RippleRegular'] text-[24px] uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "bg-black pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 !border-b border-[#444444]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover",
        title: "text-white font-['RippleRegular'] text-[30px] uppercase text-left leading-[110%]",
        subtitle: "text-[#a7a7a7] font-['CormorantGaramondRegular'] text-[15px] text-left",
        button:
          "mt-2 bg-[#000000] border border-white px-6 py-4 text-white font-['EBGaramondRegular'] text-base text-left !w-fit",
        questions: "text-[15px] text-left text-[#a7a7a7] mt-1",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 !border-b border-[#444444]",
        header: "text-white font-['RippleRegular'] text-[30px] uppercase text-left leading-[110%]",
        text: "text-white font-['CormorantGaramondRegular'] text-[15px] text-left",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 !border-b border-[#444444]",
        header: "text-white font-['RippleRegular'] text-[30px] uppercase text-left leading-[110%]",
        text: "text-white font-['CormorantGaramondRegular'] text-[15px] text-left",
        map: "h-[206px] overflow-hidden border border-[#444444] gap-y-[10px]",
        mapPinColor: "#ffffff",
        mapStrokeColor: "#6d6d6d",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-white font-['RippleRegular'] text-[30px] uppercase text-left leading-[110%]",
        text: "text-white font-['CormorantGaramondRegular'] text-[15px] text-left",
      },
      tickets: {
        header:
          "text-white font-['RippleRegular'] text-[24px] uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-black border border-black rounded-[24px] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "border border-white px-3 py-2 text-white font-['CormorantGaramondRegular'] text-[15px] text-left !w-fit rounded-lg",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto py-4 !border-b !border-[#444444]",
          media: "!hidden",
          name: "text-white font-['RippleRegular'] text-[14px] uppercase text-left leading-[110%]",
          description:
            "text-[#a7a7a7] font-['CormorantGaramondRegular'] text-[15px] text-left leading-[120%] !mt-1",
          price:
            "text-[#a7a7a7] font-['RippleRegular'] text-[14px] uppercase text-left leading-[110%] !mt-1",
          quantity: "text-white font-['CormorantGaramondRegular'] text-[15px] text-left",
          status:
            "text-[#a7a7a7] font-['RippleRegular'] text-[14px] uppercase text-left leading-[110%]",
          counterContainer: "border-2 border-white px-4 py-3 gap-x-4 !w-fit !h-10",
          button:
            "border-2 border-white px-4 py-3 text-white font-['CormorantGaramondRegular'] text-[15px] text-left !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default blockula
